import React, { Component } from "react";
import { oneOfType, number, string, arrayOf, shape, func, bool } from "prop-types";
import ReactTooltip from 'react-tooltip';

class ContextMenu extends Component {
  static propTypes = {
    left: oneOfType([number, string]).isRequired,
    top: number.isRequired,
    options: arrayOf(
      shape({
        label: string.isRequired,
        onClick: func.isRequired,
        isDisabled: bool,
        disabledMessage: string
      }),
    ).isRequired,
  };

  render() {
    const { options, left, top } = this.props;

    return (
      <>
        <ul
          className="contextmenu"
          // subtract 10 for cursor height
          style={{ left: left, top: top - 10 }}
        >
          {options.map((option, $o) =>  (
              <li
                key={$o}
                className={`contextmenu-item`}
                style={{
                  cursor: option.isDisabled ? "not-allowed" : "pointer",
                  opacity: option.isDisabled ? 0.7 : 1
                }}
                onClick={option.isDisabled ? undefined : option.onClick} 
                data-tip={(option.isDisabled && option.disabledMessage) ? option.disabledMessage : undefined}
              >
                {option.label}
              </li>
            ))}
        </ul>
        <ReactTooltip />
      </>
    );
  }
}

export default ContextMenu;